module.exports = __webpack_public_path__ + "media/images/bcsuccess-6d3a5bc3.gif";